import * as Actions from "../actions/UploadAction";

const initialState = {
  responseImage: "",
};

export default (state = initialState, action) => {
  // console.log(state)
  switch (action.type) {
    case Actions.SET_RES:
      return { ...state, responseImage: action.res };
    default:
      return state;
  }
};
